import { AnimatedSprite, Container, Text } from 'pixi.js';
import { TextureFactory } from '../core';
import { outQuint } from '../util';
import EmotionData from './Emotion.json';

export default class Emotion extends Container {
  private animatedSprite: AnimatedSprite;
  public dt: number;

  constructor() {
    super();
    const textures = TextureFactory.instance.load(EmotionData);
    this.animatedSprite = new AnimatedSprite(textures);
    this.animatedSprite.anchor.set(0.5);
    this.dt = 0;
    this.alpha = 0;
    this.scale.set(0);

    this.addChild(this.animatedSprite);
  }

  public setEmotion(name: string, frame: number): void {
    this.dt = 0;
    this.animatedSprite.gotoAndStop(frame);
    this.animatedSprite.anchor.set(0.5);

    if (name) {
      const nameTag = new Text(name, {
        fontSize: 24,
        fontWeight: '700',
        fontFamily: 'gaegu',
        fontStyle: 'normal',
        align: 'center',
        lineJoin: 'round',
        fill: 0xffffff,
        stroke: 0x000000,
        strokeThickness: 4,
      });
      nameTag.anchor.set(0.5);
      nameTag.y = this.animatedSprite.height / 2 + nameTag.height / 2 + 4;

      this.addChild(nameTag);
    }
  }

  public update(elapsed: number): void {
    this.animatedSprite.position.set(0, 0);

    if (this.dt <= 60) {
      this.alpha = outQuint(this.dt / 60) * 0.6;
      this.scale.set(outQuint(this.dt / 60) * 0.8);
    } else if (this.dt <= 120) {
      this.alpha = outQuint((120 - this.dt) / 60) * 0.6;
      this.scale.set(outQuint((120 - this.dt) / 60) * 0.8);
    } else {
      this.alpha = 0;
      this.scale.set(0);
    }
    this.dt += elapsed;
  }
}
